import axios from 'axios';

const API_BASE = 'https://api.quran.com/api/v4';

/**
 * Quran API Service
 * Documentation: https://api-docs.quran.foundation/docs/
 */

export const quranApi = {
  /**
   * Get all chapters (surah)
   */
  getAllSurah: async () => {
    try {
      const response = await axios.get(`${API_BASE}/chapters`);
      return response.data.chapters;
    } catch (error) {
      console.error('Error fetching surah:', error);
      throw error;
    }
  },

  /**
   * Get surah detail with verses
   * @param {number} surahNumber - Surah number (1-114)
   * @param {string} language - Translation language (default: 'id')
   */
  getSurahVerses: async (surahNumber, language = 'id') => {
    try {
      const response = await axios.get(
        `${API_BASE}/chapters/${surahNumber}/verses`,
        {
          params: {
            language,
            words: true,
            word_fields: 'text_uthmani text_indop transliteration',
            fields: 'text_uthmani'
          }
        }
      );
      return response.data.verses;
    } catch (error) {
      console.error('Error fetching verses:', error);
      throw error;
    }
  },

  /**
   * Get specific verse (ayah)
   * @param {number} surahNumber - Surah number (1-114)
   * @param {number} verseNumber - Verse number
   */
  getVerse: async (surahNumber, verseNumber) => {
    try {
      const response = await axios.get(
        `${API_BASE}/verses/by_key/${surahNumber}:${verseNumber}`,
        {
          params: {
            language: 'id',
            words: true,
            word_fields: 'text_uthmani text_indop transliteration',
            fields: 'text_uthmani'
          }
        }
      );
      return response.data.verse;
    } catch (error) {
      console.error('Error fetching verse:', error);
      throw error;
    }
  },

  /**
   * Search verses by keyword
   * @param {string} keyword - Search keyword
   */
  searchVerses: async (keyword) => {
    try {
      const response = await axios.get(
        `${API_BASE}/verses/search`,
        {
          params: {
            keyword,
            language: 'id',
            words: true
          }
        }
      );
      return response.data.search.results;
    } catch (error) {
      console.error('Error searching verses:', error);
      throw error;
    }
  },

  /**
   * Get audio recitation for a verse
   */
  getAudio: async (surahNumber, verseNumber) => {
    try {
      const response = await axios.get(
        `${API_BASE}/verses/by_key/${surahNumber}:${verseNumber}`,
        {
          params: {
            audio: true,
            audio_fields: 'url'
          }
        }
      );
      return response.data.verse.audio.url;
    } catch (error) {
      console.error('Error fetching audio:', error);
      throw error;
    }
  }
};

export default quranApi;
